<template>
  <b-modal ref="modal" size="xl" title="Vincular Produto" hide-footer no-close-on-backdrop>
    <div class="row mb-4">
      <div class="col-md-4">
        <b>{{ purchase_product.xProd }}</b>
      </div>
    </div>
    
    <div class="row mb-4">
      <div class="col-md-6 border-right text-center">
        <span>Utilizar produto existente</span>
        <br>
        <br>
        <div class="row">
          <div class="col-md-8 offset-2">
            <product-select @input="handleSelectProduct($event)"/>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-center">
        <span>Cadastrar Novo Produto</span>
        <br>
        <br>
        <button class="btn btn-success" @click="handleNewProduct()">Novo Produto</button>
        <!-- {{ storedProduct }} -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-secondary mr-2"   @click="$refs.modal.hide()">Cancelar</button>
        <button class="btn btn-success" @click="handleConfirm()">Confirmar</button>
      </div>
    </div>

    
    <product-form ref="productForm" @stored="handleNewProductStored($event)" />

  </b-modal>
</template>

<script>

import productForm from "@/components/product/forms/ProductForm.vue";
import productSelect from "@/components/product/inputs/ProductSelect";

export default {
  components: { productForm, productSelect },

  data: () => ({
    purchase_product: {},

    storedProduct : null,

    product : null,
  }),

  methods: {
    open(purchase_product) {
      this.purchase_product = JSON.parse(JSON.stringify(purchase_product)); 

      this.$refs.modal.show();
    },

    handleSelectProduct(product_base) {
      if (product_base !== null) {
       this.purchase_product.product_base = product_base;
       this.purchase_product.product_variant = product_base.product_variant;
       this.purchase_product.product_company = product_base.product_variant.product_company;
      } else {
       this.purchase_product.product_base = null;
       this.purchase_product.product_variant = null;
       this.purchase_product.product_company = null;
      }
    },

    handleConfirm() {
      this.$emit('input', this.purchase_product)
      this.$refs.modal.hide();
    },

    handleNewProduct() {
      this.$refs.productForm.open(null,this.purchase_product.product)
    },

    async handleNewProductStored(product) {
      this.storedProduct = product

      await this.loadStoredProduct(this.storedProduct.id)

      this.purchase_product.product_base = JSON.parse(JSON.stringify(this.product))
      this.purchase_product.product_variant = JSON.parse(JSON.stringify(this.product.product_variant[0]))
      this.purchase_product.product_company = JSON.parse(JSON.stringify(this.product.product_variant[0].product_company[0]))

      this.$emit('input',this.purchase_product)
      this.$refs.modal.hide();
    },

    async loadStoredProduct(id) {
      let response = await this.$store.dispatch("product/getProduct", id);

      this.product = response.product
    }
  },
};
</script>

<style>
</style>